import Axios from "axios";
import { url, affiliatesUrl, subscriptionKey } from "../constants";
import { buildFormData } from "../utils/utils";

export const Api = async (reqType, apiRouteUrl, body, isFormData = false) => {
  try {
    let tokenHeader = "";
    if (localStorage.getItem("_token")) {
      tokenHeader = localStorage.getItem("_token");
    }
    if (isFormData === true) {
      //formdata object
      const requestOptions = {
        method: reqType,
        headers: {
          "Ocp-Apim-Subscription-Key": subscriptionKey,
          Authorization: tokenHeader,
        },
        body: body,
      };

      let APIURL = url + apiRouteUrl;
      let response = await fetch(APIURL, requestOptions);
      let data = [];

      if (response.status == 200 || response.status == 202) {
        data = await response.json();
      } else {
        data = [];
      }
      return data;
    } else {
     const requestOptions = {
        method: reqType,
        headers: {
          "Ocp-Apim-Subscription-Key": subscriptionKey,
          "Content-Type": "application/json",
          Authorization: tokenHeader,
        },
      };
 
      // Add body only if not null / undefined
      if (body !== null && body !== undefined) {
        requestOptions.body = JSON.stringify(body);
      }

      let response = await fetch(url + apiRouteUrl, requestOptions);
      let data = null;
      const contentType = response.headers.get("content-type");

      if (
        response?.status !== 204 &&
        contentType?.includes("application/json")
      ) {
        try {
          data = await response.json();
        } catch (e) {
          console.warn("Empty or invalid JSON body");
          data = {};
        }
      }
      return data;
    }
  } catch (err) {
    console.error("Request Error:", err);

    // Network error
    if (err?.message === "Network Error") {
      throw { code: 403 };
    }

    // Axios error with HTTP code
    if (Axios.isAxiosError(err) && err.response?.status === 403) {
      throw { code: 403 };
    }

    // Fallback for unknown error
    throw err;
  }
};

export const affiliatesApi = async (
  method,
  routeUrl,
  body,
  isFormData = false
) => {
  return fetch(affiliatesUrl + routeUrl, {
    method: method,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
    },
    body: body,
  })
    .then((res) => res.json())
    .then((data) => {
      return data;
    })
    .catch((err) => {
      throw err;
    });
};

export const fetchFileWithId = async (id) => {
  try {
    let res = await Axios({
      method: "get",
      url: `${url}/files/${id}`,
      responseType: "blob",
      headers: {
        "Ocp-Apim-Subscription-Key": subscriptionKey,
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("_token") ?? "",
        menuUrl: window.localStorage.getItem("menuUrl"),
      },
    });
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const fetchFileFromUrl = async (fileUrl) => {
  try {
    let res = await Axios({
      method: "get",
      url: `${url}/common/docView?filePath=${fileUrl}`,
      // responseType:"blob",
      headers: {
        "Ocp-Apim-Subscription-Key": subscriptionKey,
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("_token") ?? "",
        menuUrl: window.localStorage.getItem("menuUrl"),
      },
    });
    return res.data;
  } catch (error) {
    if (error.response) {
      throw error.response.data.message;
    } else {
      throw error.message;
    }
  }
};

export const stripiApi = async (method, routeUrl, body) => {
  const options = {
    method,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization:
        "Bearer f6d339b022ba3b2463ccd4c6690960392d02613bbaa67e278d552a7ce09f08e4c12c12dc8f5ea2d32e803c76abd0677a93a0b82eb8ff24354f92560b0540f08cd3258dd22276aaad35107e993930f9cd7482ef4d7020064b94effb3529ea05fd8b16fc89af0404386f92f60993ae2e25ab3d146a5e85d6983fcc6ebcb5821dea",
    },
  };

  if (body && method !== "GET") {
    options.body = JSON.stringify(body);
  }

  try {
    const response = await fetch(routeUrl, options);
    return await response.json();
  } catch (error) {
    console.error("Strapi API Error:", error);
    throw error;
  }
};

export const deleteDocById = async (docId, type) => {
  const tokenHeader = localStorage.getItem("_token") || "";
  try {
    const deleteUrl =
      type === "moa"
        ? "deleteMemorandumDocument"
        : type === "trade"
        ? "deleteTradeLicense"
        : "deleteDocById";
    let response = await fetch(
      `${url}/documents/${deleteUrl}/${Number(docId)}`,
      {
        method: "DELETE",
        headers: {
          "Ocp-Apim-Subscription-Key": subscriptionKey,
          Authorization: tokenHeader,
        },
        redirect: "follow",
      }
    );
    if (response?.status === 200) {
      return true;
    } else {
      let response = await response?.json();
      throw new Error(response?.message || "Failed to delete document");
    }
  } catch (error) {
    console.error("Error deleting document:", error);
    throw error;
  }
};

export const uploadOrUpdateDocuments = async ({
  documentInfoId,
  merchantId,
  uploadedFiles,
  entityId,
  entityType = "COMPANY",
  docPrintedId = null,
  docIssueDate = new Date().toISOString().split("T")[0],
  docCountry = "UAE",
}) => {
  try {
    const formData = buildFormData({
      documentInfoId,
      merchantId,
      uploadedFiles,
      entityId,
      entityType,
      docPrintedId,
      docIssueDate,
      docCountry,
    });
    const url = entityId
      ? "/documents/uploadOrUpdateDocuments"
      : "/documents/uploadOrUpdate";
    const response = await Api("POST", url, formData, true);

    console.log("Upload response:", response);

    if (response && response.success) {
      // Map response docIds to newly uploaded files
      let newDocIndex = 0;
      const updatedFiles = uploadedFiles.map((file) => {
        if (
          !file.docId &&
          file.fileObject &&
          response.body &&
          response.body[newDocIndex]
        ) {
          const updatedFile = {
            ...file,
            docId: response.body[newDocIndex].docId,
            fileId: response.body[newDocIndex]?.file?.id,
          };
          newDocIndex++;
          return updatedFile;
        }
        return file;
      });

      return { success: true, files: updatedFiles, response };
    }

    return { success: false, files: uploadedFiles, response };
  } catch (error) {
    console.error("Error uploading documents:", error);
    return { success: false, files: uploadedFiles, error };
  }
};
